import {Component, EventEmitter, Output} from '@angular/core';
import {upcaseFirst} from '../../../helpers/upcase-first';
import { FormButtonsComponent } from '../../../helpers/form/form-buttons/form-buttons.component';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { FormInputErrorsComponent } from '../../../helpers/form/form-input-errors/form-input-errors.component';
import { BijbFormDirective } from '../../../helpers/form/directives/bijb-form.directive';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-create-event',
    templateUrl: './create-event.component.html',
    styleUrls: ['./create-event.component.scss'],
    standalone: true,
    imports: [FormsModule, BijbFormDirective, FormInputErrorsComponent, NgxTrimDirectiveModule, FormButtonsComponent]
})
export class CreateEventComponent {
  @Output()
  public submitted = new EventEmitter<string>();

  public eventName = '';

  public createEvent(): void {
    this.submitted.next(upcaseFirst(this.eventName));
  }
}
